<template>
    <div v-if="dataConsiderations.length > 0">
        <h2>Conditions</h2>
        <p>Consideration: <strong>{{ currentConsideration.name }}</strong></p>

        <table v-if="local.conditions.length" class="table border-bottom">
            <tr v-for="(condition, index) in sortedCondtitions">
                <th class="text-right">
                    <span v-html="conditionLabel(condition.sequence)"></span>
                </th>
                <td>
                    <input type="text" v-model="condition.name" :readonly="(index != activeConditionIndex)" class="form-control" :class="(index == activeConditionIndex) ? '':'readonly'">
                </td>
                <td>
                    <button :class="(index == activeConditionIndex) ? 'active':''" class="btn btn-outline-secondary btn-sm" @click="editCondition(index)">
                        <i v-if="(index == activeConditionIndex)" class='far fa-save'></i>
                        <i v-else="(index == activeConditionIndex)" class='far fa-edit'></i>
                    </button>
                    <button v-if="condition.sequence > ConditionTypesEnum.BEST && condition.sequence < ConditionTypesEnum.WORST"
                        class="btn btn-sm btn-outline-danger"
                        @click="removeCondition(index)"><i class="fa fa-times"></i>
                    </button>
                </td>
                <!-- TODO: Edit / move conditions -->
            </tr>
        </table>

        <form>
            <div v-if="errors.length" class="alert alert-warning">
                <ul>
                    <li v-for="error in errors">{{ error }}</li>
                </ul>
            </div>

            <h5>{{ conditionIntro }}</h5>
            <div class="form-group row" v-if="conditionType === ConditionTypesEnum.OTHER">
                <div class="btn-group">
                    <button type="button" class="btn btn-secondary" @click.prevent="showForm = true">Yes, add another</button>
                    <button type="button" class="btn btn-secondary" @click="considerationComplete">No, I'm done</button>
                </div>
            </div>

            <div class="form-group row" v-if="showForm">
                <label class="col-form-label col-md-2" for="conditionName">Scenario</label>
                <div class="col-md">
                    <input type="text" class="form-control" id="conditionName" v-model="local.condition.name" @keypress.enter.prevent="addCondition">
                </div>
                <div class="col-md-2">
                    <input type="button" class="btn btn-primary" value="Add" @click.prevent="addCondition">
                </div>
            </div>
        </form>
        <div class="row justify-content-center">
            <input type="button" class="btn btn-secondary" value="Previous consideration" @click="prevConsideration" v-if="considerationIndex > 0">
            <input type="button" class="btn btn-secondary" value="Next consideration" @click="nextConsideration" :disabled="!hasMinimumConditions" v-if="!lastConsideration">
            <input type="button" class="btn btn-success" value="Next" @click="nextStep" :disabled="!considerationConditionsComplete">
        </div>

    </div>
</template>

<script>
import {mapMutations, mapState} from 'vuex';
import {modalMixin} from '../mixins/modal';

import ConditionTypesEnum from '../types/ConditionTypesEnum';

export default {
    mixins: [
        modalMixin,
    ],
    data() {
        return {
            local: {
                conditions: [],
                condition: {
                    name: '',
                },
            },
            considerationIndex: 0,
            conditionType: ConditionTypesEnum.BEST,
            ConditionTypesEnum: ConditionTypesEnum,
            errors: [],
            showForm: true,
            activeConditionIndex: -1,
        };
    },
    methods: {
        ...mapMutations('data', [
            'commitConditions',
        ]),
        pushCondition(condition) {
            const vm = this;
            vm.local.conditions.push(condition);
            vm.$set(vm.local, 'conditions', _.sortBy(vm.local.conditions, 'sequence'));
        },
        addCondition() {
            const vm = this;

            if (vm.validate()) {
                let condition = _.clone(vm.local.condition);
                _.merge(condition, {sequence: vm.nextSequence()});
                vm.pushCondition(condition);
                vm.nextCondition();

                vm.local.condition.name = '';
                vm.showForm = false;
            }
        },
        nextCondition() {
            const vm = this;
            switch (vm.conditionType) {
                case ConditionTypesEnum.BEST:
                    vm.conditionType = ConditionTypesEnum.WORST;
                    break;
                case ConditionTypesEnum.WORST:
                    vm.conditionType = ConditionTypesEnum.OTHER;
                    break;
            }
        },
        nextSequence() {
            const vm = this;
            return vm.conditionType === ConditionTypesEnum.WORST ? ConditionTypesEnum.WORST : vm.local.conditions.length;
        },
        considerationComplete() {
            const vm = this;
            // Store conditions
            //TODO: Move commit to addCondition to reduce potential data loss
            vm.commitConditions({
                index: vm.considerationIndex,
                conditions: vm.local.conditions,
            });
            // Reset local variable
            vm.$set(vm.local, 'conditions', []);

            // If more considerations, advance to next, otherwise next step
            if (!vm.nextConsideration()) {
                vm.nextStep();
            }
        },
        conditionLabel(sequence) {
            let label = '';
            switch (sequence) {
                case ConditionTypesEnum.BEST:
                    label = 'Most supportive description for the decision';
                    break;
                case ConditionTypesEnum.WORST:
                    label = 'Strongest description that opposes the decision';
                    break;
            }

            if (label) {
                label += '<span class="px-2">&rarr;</span>';
            }

            return label;
        },
        restoreConditions() {
            const vm = this;

            if(vm.$store.state.data.matrix.considerations.length > 0) {
                if (_.isArray(vm.$store.state.data.matrix.considerations[vm.considerationIndex].conditions)) {

                    vm.local.conditions = _.clone(vm.$store.state.data.matrix.considerations[vm.considerationIndex].conditions);
                    if (_.find(vm.local.conditions, (item) => {
                        return item.sequence == ConditionTypesEnum.WORST;
                    })) {
                        vm.conditionType = ConditionTypesEnum.OTHER;
                    }
                    else if (_.find(vm.local.conditions, (item) => {
                        return item.sequence == ConditionTypesEnum.BEST;
                    })) {
                        vm.conditionType = ConditionTypesEnum.WORST;
                    }
                    else {
                        vm.conditionType = ConditionTypesEnum.BEST;
                    }
                }
            }
        },
        removeCondition(index) {
            const vm = this;
            vm.confirmAction('Are you sure you want to remove this condition?').then(value => {
                if (value) {
                    vm.$delete(vm.local.conditions, index);
                }
            });
        },
        validate() {
            const vm = this;
            vm.$set(vm, 'errors', []);

            if (_.isEmpty(vm.local.condition.name)) {
                vm.errors.push('Condition cannot be blank');
            }

            return vm.errors.length === 0;
        },
        nextConsideration() {
            const vm = this;
            if (!vm.lastConsideration) {
                vm.considerationIndex++;
                vm.conditionType = ConditionTypesEnum.BEST;
                vm.restoreConditions();
                return true;
            }
            return false;
        },
        prevConsideration() {
            const vm = this;
            if (vm.considerationIndex > 0) {
                vm.considerationIndex--;
                vm.restoreConditions();
            }
        },
        nextStep() {
            this.$router.push({name: 'scores'});
        },
        editCondition(index) {
            if(this.activeConditionIndex == index) {
                this.activeConditionIndex = -1;
            }else{
                this.activeConditionIndex = index;
            }
        },
    },
    watch: {
        'conditionType': function(type) {
            if (this.conditionType === ConditionTypesEnum.OTHER) {
                this.showForm = false;
            }
            else {
                this.showForm = true;
            }
        },

        dataConsiderations: function () {
            console.log('data consideration is updated')
            this.restoreConditions();
        }
    },
    computed: {
        ...mapState('data', {
            dataConsiderations: state => state.matrix.considerations,
        }),
        currentConsideration: function() {
            return this.dataConsiderations[this.considerationIndex];

        },
        conditionIntro() {
            switch (this.conditionType) {
                case ConditionTypesEnum.BEST:
                    return 'Most supportive description for the decision';
                    break;
                case ConditionTypesEnum.WORST:
                    return 'Strongest description that opposes the decision';
                    break;
                default:
                case ConditionTypesEnum.OTHER:
                    return 'Is there another consideration between the most supportive description and the description that opposes the decision?';
            }
        },
        hasMinimumConditions() {
            return this.currentConsideration.conditions.length >= 2;

        },
        considerationConditionsComplete() {
            for (var i in this.dataConsiderations) {
                if (this.dataConsiderations[i].conditions.length < 2) {
                    return false;
                }
            }

            return true;
        },
        lastConsideration() {
            const vm = this;
            return vm.considerationIndex == vm.dataConsiderations.length - 1
        },
        sortedCondtitions() {
            return _.orderBy(this.local.conditions, ['sequence'])
        }
    },
    mounted() {
        this.restoreConditions();
        this.restoreConditions();

        //TODO: Force route back to considerations if empty
    },
    //TODO: Warn on changes not saved

};
</script>

<style scoped>
    .readonly {
        background-color: transparent;
        border-width: 0;
    }
</style>
